module.exports = __webpack_public_path__ + "files/Spotlight on skills Workshop Templates.92d081de.pptx";